import React from 'react';

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import ReactDOM from 'react-dom'

export class Article extends React.Component {
    constructor(props) {
        super(props);

        this.articleUrl = "";
        this.articleTitle = "";

        this.loading = false;

        this.updateArticleData = this.updateArticleData.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onSelect = this.onSelect.bind(this);

        if (!this.props.articleUrl || !this.props.articleTitle) this.updateArticleData();
        else {
            this.articleTitle = this.props.articleTitle;
            this.articleUrl = this.props.articleUrl;
        }
    }

    async updateArticleData() {
        this.loading = true;
        this.forceUpdate();
        let res = await (await fetch("https://fr.wikipedia.org/w/api.php?format=json&action=query&generator=random&grnnamespace=0&prop=info&inprop=url&grnlimit=1&origin=*")).json();
        console.log(res);
        console.log(res.query.pages)

        let pages = res.query.pages;
        let first = pages[Object.keys(pages)[0]];
        this.articleUrl = first.canonicalurl;
        this.articleTitle = first.title;
        console.log(this.articleUrl)
        this.loading = true;
        this.forceUpdate();
    }

    onSelect() {
        this.props.socket.send(JSON.stringify({ kind: "selectArticle", title: this.articleTitle }));
        this.props.onSelect(this.articleTitle, this.articleUrl);
    }

    onLoad() {
        this.loading = false;
        this.forceUpdate();
    }

    isTouchDevice() {
        return "ontouchstart" in window;
    }

    render() {
        let tooltip = (<div></div>);

        if (!this.isTouchDevice()) {
            tooltip = <Tooltip id="tooltip-refresh ontouch">
                          Cliquez pour sélectionner : vous pourrez utiliser la barre espace pour rafraichir plus facilement.
                      </Tooltip>;
        }

        let refreshContent;

        if (this.loading) {
            refreshContent = <i className="fas fa-sync-alt fa-spin"></i>;
        } else {
            refreshContent = <i className="fas fa-sync-alt"></i>;
        }

        return (<div className="outer-article">
            <Container className="pb-2 pt-2 top-article">
                <Row>
                    <Col className="text-left">
                        <OverlayTrigger
                            key="bottom"
                            placement="bottom"
                            overlay={tooltip}
                        >
                            <Button variant="primary" onClick={this.updateArticleData}>
                                {refreshContent}
                            </Button>
                        </OverlayTrigger>
                    </Col>
                    <Col xs={7} className="text-center article-title">
                        {this.articleTitle}
                    </Col>
                    <Col className="text-right">
                        <Button variant="success" disabled={Object.is(this.articleTitle, undefined)} onClick={this.onSelect}>
                            <i className="fas fa-check"></i>
                        </Button>
                    </Col>
                </Row>
            </Container>

            <iframe src={this.articleUrl} className="wiki-content frame-article" onLoad={this.onLoad}></iframe>
        </div>);
    }
}